<style>
@import '../../../custom/css/editar-dica.css';
</style>

<template>
  <div class="editar-dica">
    <div class="form-fields position-relative" v-if="banner !== null">
      <h1 class="title text-uppercase font-weight-bold">Ver Banner</h1>
      <hr class="linha-amarela" />
      <div class="form-group" v-if="banner[0].imagem !== null">
        <div class="box-img mb-4 shadow">
          <img
            :src="`${getImagesAddress}` + banner[0].imagem"
            alt="Imagem do banner"
            class="obj my-img-fluid w-100 h-100"
          />
        </div>
      </div>
      <div class="form-group" v-if="banner[0].cidade !== null">
        <label for="cadastroCidade">Cidades:</label>
        <div v-if="banner[0].cidades.length > 0">
          <div v-for="cidade in banner[0].cidades">
            <div class="col-12">{{ cidade.nome }}</div>
          </div>
        </div>
        <div v-if="banner[0].todos === true">
          <div class="col-12">Sem Cidade</div>
        </div>
        <div v-if="banner[0].privadas === true">
          <div class="col-12">Todas as Cidade Privadas</div>
        </div>
      </div>
      <div class="form-group" v-if="banner[0].url !== null">
        <label for="cadastroUrl">URL</label>
        <div>{{ banner[0].url }}</div>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="editarBanner()">Editar</div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse banner não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import api from '../../../api/index';

export default {
  name: 'ver-banner',
  data: () => ({}),
  props: ['id'],
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getInformacaoUpload',
    ]),
    ...mapState({
      banner: (state) => state.banner,
      cidades: (state) => state.cidades,
    }),
  },
  created() {
    this.$store.dispatch('showBanner', this.id);
  },
  activated() {
    this.$store.dispatch('showBanner', this.id);
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    editarBanner(id) {
      this.$router.push({
        name: 'administrador-editar-banner',
        params: { id },
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lista-banners',
      });
    },
  },
};
</script>
